import { Button, forwardRef } from '@chakra-ui/react';
import React from 'react';
import StyledLink from '../StyledLink';
var ButtonLink = forwardRef(function (props, forwardedRef) {
  var _cta$internalLink, _cta$internalLink$, _cta$internalLink2, _cta$internalLink2$, _cta$externalLink, _cta$externalLink$tar, _cta$externalLink2;

  var cta = props.cta,
      onClick = props.onClick,
      state = props.state;
  if (!props.cta) return null;
  var styleProps = Object.assign({}, props.color ? {
    color: props.color
  } : {}, props.bg ? {
    bg: props.bg
  } : {}, props.mb ? {
    mb: props.mb
  } : {});
  return /*#__PURE__*/React.createElement(StyledLink, {
    key: (cta === null || cta === void 0 ? void 0 : (_cta$internalLink = cta.internalLink) === null || _cta$internalLink === void 0 ? void 0 : (_cta$internalLink$ = _cta$internalLink[0]) === null || _cta$internalLink$ === void 0 ? void 0 : _cta$internalLink$.uri) + "-" + (cta === null || cta === void 0 ? void 0 : cta.label),
    anchorId: cta === null || cta === void 0 ? void 0 : cta.anchor,
    to: cta === null || cta === void 0 ? void 0 : (_cta$internalLink2 = cta.internalLink) === null || _cta$internalLink2 === void 0 ? void 0 : (_cta$internalLink2$ = _cta$internalLink2[0]) === null || _cta$internalLink2$ === void 0 ? void 0 : _cta$internalLink2$.uri,
    href: cta === null || cta === void 0 ? void 0 : (_cta$externalLink = cta.externalLink) === null || _cta$externalLink === void 0 ? void 0 : _cta$externalLink.url,
    target: (_cta$externalLink$tar = cta === null || cta === void 0 ? void 0 : (_cta$externalLink2 = cta.externalLink) === null || _cta$externalLink2 === void 0 ? void 0 : _cta$externalLink2.target) !== null && _cta$externalLink$tar !== void 0 ? _cta$externalLink$tar : '_self',
    state: state
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    variant: cta === null || cta === void 0 ? void 0 : cta.variant,
    ref: forwardedRef,
    onClick: onClick
  }, styleProps), cta === null || cta === void 0 ? void 0 : cta.label));
});
export default ButtonLink;